import {OperationState} from './types';

export const DEFAULT_EXAM_RESULT_OPERATION_STATE: Partial<OperationState> = {
	loading: false,
	error: false,
	errorType: 'none',
	isShareAction: false,
	medicalReport: null,
};
